import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../services/api";

export default function usePageTrack() {
  const location = useLocation();

  useEffect(() => {
    api.post("/api/track", { page: location.pathname }).catch(() => {}); // silent fail — never block the user
  }, [location.pathname]);
}
